import { pushDataLayerEvent } from '@alwindows/shared'

/**
 * GTM events for the spare-parts flow — name + payload identical to the
 * legacy app (al_spare_parts: EVENT_SP_FILTER_SEARCH = "spare_parts_search",
 * `{ event, searchTerm }`) so the existing GTM triggers keep firing.
 */
export function trackSpareSearch(searchTerm: string): void {
  pushDataLayerEvent('spare_parts_search', { searchTerm })
}
